import React, { FC, useCallback, useRef, useState } from 'react'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  IconButton,
  Spinner,
  useDisclosure
} from '@chakra-ui/react'

import { TrashIcon } from 'components/TailwindUIToolkit/StyledComponents'
import { useDeleteRecurringCreditMutation } from 'graphql/generated'

interface DeleteButtonProps {
  onSuccess?: () => void | Promise<void>
  recurringCreditId: string
}
export const DeleteButton: FC<React.PropsWithChildren<DeleteButtonProps>> = ({
  onSuccess,
  recurringCreditId
}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const [_rc, deleteRecurringCredit] = useDeleteRecurringCreditMutation()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef(null)

  const handleDeletion = useCallback(async () => {
    setIsDeleting(true)
    try {
      const result = await deleteRecurringCredit({ recurringCreditId })

      if (!result.error) {
        await onSuccess?.()
        onClose()
      }
    } finally {
      setIsDeleting(false)
    }
  }, [deleteRecurringCredit, onClose, onSuccess, recurringCreditId])

  return (
    <>
      <IconButton
        size='xs'
        disabled={isDeleting}
        aria-label={`Delete recurring credit`}
        icon={isDeleting ? <Spinner /> : <TrashIcon />}
        onClick={onOpen}
      />
      <AlertDialog isOpen={isOpen} onClose={onClose} leastDestructiveRef={cancelRef}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Delete Recurring Credit
            </AlertDialogHeader>
            <AlertDialogFooter>
              <Button size='xs' isDisabled={isDeleting} ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                size='xs'
                isDisabled={isDeleting}
                colorScheme='red'
                ml={3}
                onClick={handleDeletion}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
